import { Platform, Share } from 'react-native';

/**
 * Copies text to the clipboard cross-platform.
 * Web: uses Clipboard API with textarea fallback.
 * Native: opens the system share sheet with the text as the message.
 */
export async function copyText(text: string): Promise<void> {
  if (Platform.OS === 'web' && typeof navigator !== 'undefined') {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      copyToClipboardFallback(text);
    }
  } else {
    await Share.share({ message: text });
  }
}

/**
 * DOM textarea fallback for copying text on web when Clipboard API is unavailable.
 * No-op on native platforms.
 */
export function copyToClipboardFallback(text: string): void {
  if (Platform.OS !== 'web' || typeof document === 'undefined') return;
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
}
